import { create } from 'zustand'

/**
 * Storm-Mode session state. `autoEnteredId` remembers the warning we last auto-opened
 * the takeover for, so a fresh warning yanks the user in exactly once — and exiting
 * back home doesn't immediately re-trap them. In-memory by design (a reload starts
 * fresh; a still-active warning simply re-triggers, which is the right call).
 */
interface StormState {
  autoEnteredId: string | null
  markAutoEntered: (id: string) => void
}

export const useStormStore = create<StormState>((set) => ({
  autoEnteredId: null,
  markAutoEntered: (id) => set({ autoEnteredId: id }),
}))
